//Name Comparison function
export function nameCompareAZ(x, y){
    if(x.nombre >= y.nombre){
        return 1;
    }else{
        return -1;
    }
}

export function nameCompareZA(x, y){
    if(x.nombre >= y.nombre){
        return -1;
    }else{
        return 1;
    }
}

//Price Comparison function
export function priceCompareMinor(x, y){
    if(x.lista1 > y.lista1){
        return 1;
    }else if(x.lista1 == y.lista1){
        return 0;
    }else{
        return -1;
    }
}

export function priceCompareMayor(x, y){
    if(x.lista1 > y.lista1){
        return -1;
    }else if(x.lista1 == y.lista1){
        return 0;
    }else{
        return 1;
    }
}

export function priceCompareMinor2(x, y){
    if(x.precio > y.precio){
        return 1;
    }else if(x.precio == y.precio){
        return 0;
    }else{
        return -1;
    }
}

export function priceCompareMayor2(x, y){
    if(x.precio > y.precio){
        return -1;
    }else if(x.precio == y.precio){
        return 0;
    }else{
        return 1;
    }
}

//Stock Comparison function
export function stockCompareMayor(x, y){
    if(x.stock >= y.stock){
        return 1;
    }else{
        return -1;
    }
}

export function stockCompareMinor(x, y){
    if(x.stock >= y.stock){
        return -1;
    }else{
        return 1;
    }
}

//Type or List comparison
export function lista1Compare(x, y){
    if(x.tipo == 1){
        return 1;
    }else{
        return -1;
    }
}

export function lista2Compare(x, y){
    if(x.stock == 2){
        return 1;
    }else{
        return -1;
    }
}

export function lista3Compare(x, y){
    if(x.stock == 3){
        return 1;
    }else{
        return -1;
    }
}

export function idCompareAsc(x, y){
    if(x.id > y.id){
        return 1;
    }else{
        return -1;
    }
}

export function idCompareDesc(x, y){
    if(x.id > y.id){
        return -1;
    }else{
        return 1;
    }
}

//Fecha Compare
export function fechaCompare(a, b){
    let x = a.fecha;
    let y = b.fecha;

    let day1 = x.replace(/\/[0-9]{2}\/[0-9]{4}/, "");

    let month1 = x.replace(/\/[0-9]{4}/, "");
    month1 = month1.replace(/[0-9]{2}\//, "");

    let year1 = x.replace(/[0-9]{2}\/[0-9]{2}\//, "");

    let date1 = new Date(year1, month1 - 1, day1);



    let day2 = y.replace(/\/[0-9]{2}\/[0-9]{4}/, "");

    let month2 = y.replace(/\/[0-9]{4}/, "");
    month2 = month2.replace(/[0-9]{2}\//, "");

    let year2 = y.replace(/[0-9]{2}\/[0-9]{2}\//, "");

    let date2 = new Date(year2, month2 - 1, day2);

    if(date1 > date2){
        return 1;
    }
    if(date1 == date2){
        return 0;
    }
    if(date1 < date2){
        return -1;
    }
}


export function fechaCompareDesc(a, b){
    let x = a.fecha;
    let y = b.fecha;

    let day1 = x.replace(/\/[0-9]{2}\/[0-9]{4}/, "");

    let month1 = x.replace(/\/[0-9]{4}/, "");
    month1 = month1.replace(/[0-9]{2}\//, "");

    let year1 = x.replace(/[0-9]{2}\/[0-9]{2}\//, "");

    let date1 = new Date(year1, month1 - 1, day1);



    let day2 = y.replace(/\/[0-9]{2}\/[0-9]{4}/, "");

    let month2 = y.replace(/\/[0-9]{4}/, "");
    month2 = month2.replace(/[0-9]{2}\//, "");

    let year2 = y.replace(/[0-9]{2}\/[0-9]{2}\//, "");

    let date2 = new Date(year2, month2 - 1, day2);

    if(date1 > date2){
        return -1;
    }
    if(date1 == date2){
        return 0;
    }
    if(date1 < date2){
        return 1;
    }
}

export function fechaCompareAZ(x, y){
    if(x.fecha >= y.fecha){
        return 1;
    }else{
        return -1;
    }
}

export function fechaCompareZA(x, y){
    if(x.fecha >= y.fecha){
        return -1;
    }else{
        return 1;
    }
}

export function fechaCompareTwoWeeks(fechaCompare, fechaNow){
   let diff = fechaNow - fechaCompare;
   if(diff > 1296000000){
    return true;
   }else{
    return false;
   }
}

export function formatFechaST(DDMMYYYY){

    let string = DDMMYYYY.replace(/ [0-9]{2}:[0-9]{2}/i, "");
    
    let day = string.replace(/\/[0-9]{2}\/[0-9]{4}/, "");
    let month = string.replace(/\/[0-9]{4}/, ""); month = month.replace(/[0-9]{2}\//, "")
    let year = string.replace(/[0-9]{2}\/[0-9]{2}\//, "");

    let date = new Date(year, month - 1, day);

    return date;
}